import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const RolePages = {
  list: 'ListRole',
  add: 'AddRole',
  edit: 'EditRole',
}

const { t } = i18n.global

const title = t('pages.listRole')
const path = '/roles'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: RolePages.add,
  component: () => import('@/pages/mainPageWithRoute/role/AddRolePage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: RolePages.edit,
  component: () => import('@/pages/mainPageWithRoute/role/EditRolePage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: RolePages.list,
  component: () => import('@/pages/mainPageWithRoute/role/ListRolePage.vue'),
  meta: { title, requiresAuth: true },
}

export const Roles: RouteRecordRaw = {
  path,
  name: 'Roles',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
